import { isValidElement, type ReactNode } from "react";

/**
 * The plain text a node renders, from its strings and numbers through
 * elements' `children`; empty for anything else, such as an input.
 */
export const getNodeText = (node: ReactNode): string => {
    if (typeof node === "string" || typeof node === "number") {
        return String(node);
    }
    if (isValidElement<{ children?: ReactNode }>(node)) {
        return getNodeText(node.props.children);
    }
    if (typeof node === "object" && node !== null && Symbol.iterator in node) {
        return Array.from(node, getNodeText).join("");
    }
    return "";
};
